/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { IState, THEME_NAMES, useMainStore } from "src/settings/zustand"
import { ILanding } from "../../data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "../../data/store"
import LandingSnapshotForm from "./LandingSnapshotForm"
import { addCSSLink } from "src/libs/layout-app/utils/addCSSLink"
import { IPanelStore, usePanelStore } from "../UIX/store"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import LandingExternalForm from "./LandingExternalForm"

const LandingForm = (props:any) :JSX.Element => { 	
	const theme: THEME_NAMES 		= useMainStore((state:IState) => state.theme)
    const settings  				= useLandingConsoleStore((state:ILandingConsoleStore) => state.settings)
    const isHidePanels: boolean     = usePanelStore((state: IPanelStore) => state.isHidePanels)
	
    const landingData              = useSyncState<ILanding | undefined>( useLandingStore.getState().currentLanding ) 
    
    
    const compareData = (newLanding: ILanding): boolean => {
        const newData = {...newLanding}
        newData.sections = []
        const oldData = {...landingData.get()}
        oldData.sections = []
        // console.log(newData)
        // console.log(oldData)        
        return JSON.stringify(oldData) === JSON.stringify(newData)
    }
    
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => {     
                if( !compareData( currentLanding ) ) {
                    // console.log( "LandingForm use effect" )
                    // console.log( landing )
                    // console.log( currentLanding )
                    landingData.set( currentLanding )
                }
            }
        )
        return () => {
            unsubscribe()
            useLandingConsoleStore.setState({ modalsOpen: [], modals: [] })
        } 
    }, [])
    /**/
    const landing = landingData.get()
    const addLandingClasses = ( landing:ILanding ) => {
        
        // console.log(landing)
        
        if(!landing) return
        addCSSClass(
            `pe-landing`,
            `
            .main-landing {
                font-family: ${ Array.isArray( landing.fonts ) && !!landing.fonts.length ? landing.fonts[0] : "Open sans"};
                font-size: ${landing.font_size || "14"}px;
                .h, h1, h2, h3, h4, h5, h6, h7 {
                    font-family: ${ Array.isArray( landing.fonts ) && landing.fonts.length > 1 ? landing.fonts[1] : landing.fonts[0] || "Open sans"}!important;
                }
            }
            
            .landing-container-fluid {
                ${ typeof landing.size === "number" ? `width: ${ getCssDemention(landing.size) }; ` : `` }
                position: relative;
            }
            .landing-background {
                width: calc(100% - ${ settings.toolPanel && !isHidePanels ? 50 : 0 }px);
                background-color: ${ 
                    theme === THEME_NAMES.DAY 
                        ?  
                        landing.background?.color || "transparent" 
                        :  
                        landing.background?.dark  || landing.background?.color || "transparent" 
                } ;
            }
            .landing-gap {
                padding: ${ getCssDemention(landing.gap), "0"};
            }
            .landing-section {
                border-radius:${ getCssDemention(landing.sectionRound, "0")}; 
            }
            .landing-delimiter {
                position:absolute;
                bottom: ${ getCssDemention( landing.delimiter?.bottom, "0px" )};
                left: ${ getCssDemention( landing.delimiter?.x)};
                width: ${ getCssDemention( landing.delimiter?.width, "100%" )  } ;
                height: ${ getCssDemention( landing.delimiter?.height, "1px" )};
                background-color: ${ landing.delimiter?.bg || "var(--force-contrast-opacity-color)" };
                z-index: 2;
            }
			${
				!!landing.hideOriginalHeader
					?
					`.landing-container {
						height: 100dvh!important;				
					}
					.layout-header, .pe-layout-header-mobyle, .pe-layout-menu-mobile-dummy {
						display: none!important;
					}`
					:
					``
			}
            ${ landing.css?.join(" ") }` 
        ) 
    }
	const getFonts = () => {        
        if(!landing || !landing.fonts) return 
        addCSSLink( [...landing.fonts] )
    }
    
	useEffect(() => {  
		useLandingStore.subscribe( (state: ILandingStore) => { 
            addLandingClasses(state.currentLanding) 
        })
        
		return () => { removeCSSClass('pe-landing') }
	}, [ settings, isHidePanels ])
	
	useEffect(() => {  
		useMainStore.subscribe( ( ) => { 
            addLandingClasses( landing || {} as ILanding )  
        }) 
        
		return () => { removeCSSClass('pe-landing') }
	}, [ settings, isHidePanels ]) 

	useEffect(() => { 
        getFonts() 
	}, [ landing ])
    
    return <>
		{	
			!!props.extend_params?.local // TODO:: source type ( local or BFF )
				? 
				<LandingSnapshotForm {...props} /> 
				: 
				<LandingExternalForm {...props} />
		}
	</>
	
} 

export default LandingForm